import { Box, styled } from '@mui/material';

const CardPadding = 24;
const TitleMargin = 200;

export const PageHeaderContainer = styled(Box)(() => ({
  marginLeft: `${TitleMargin - CardPadding}px`,

  '@media screen and (max-width: 1280px)': {
    marginLeft: `${TitleMargin / 2 - CardPadding}px`,
  },

  '@media screen and (max-width: 840px)': {
    marginLeft: `${TitleMargin / 4 - CardPadding}px`,
  },

  '@media screen and (max-width: 640px)': {
    marginLeft: 0,
  },
}));
